import { SvgIconProps } from '@mui/material'
import SvgIcon from '@mui/material/SvgIcon'
import { IconActive } from 'components/ArteelIcons/IconActive'

export const SliderSolid = ({ active, ...rest }: SvgIconProps & IconActive) => (
  <SvgIcon {...rest} viewBox="0 0 70 70">
    <path d="M35.4,2.9c-18,0-32.6,14.6-32.6,32.6S17.5,68,35.4,68C53.4,68,68,53.4,68,35.4S53.4,2.9,35.4,2.9z" />
  </SvgIcon>
)
